<!--<app-header></app-header>-->

<!--<div class="page-container">-->
<!--  <div class="page-content">-->
<!--    <div class="content-wrapper">-->

<!--      &lt;!&ndash; Industry Detail Section Start &ndash;&gt;-->
<!--      <div class="row" *ngIf="showSlide">-->
<!--        <div class="col-lg-12">-->
<!--          <div class="panel panel-flat" id="divDetails" style="color:#5A85A3; font-size: 18px;">-->

<!--            <div class="panel-body">-->

<!--              <div class="col-lg-10" *ngIf="!industryDetailsLoader && showSlide">-->

<!--                <div class="row">-->
<!--                  <div class="col-md-6">-->
<!--                     <span style="font-size: 25px;">-->
<!--                    {{industryDetails[0]['name']}}a-->
<!--                  </span>-->

<!--                    <br/>-->

<!--                    <span style="font-size: 15px; margin-left: 5px;">-->
<!--                    <i class="fa fa-map-marker" aria-hidden="true"></i>-->
<!--                      {{industryDetails[0]['address']}}-->
<!--                  </span>-->

<!--                    <span style="font-size: 15px; margin-left: 5px;">-->
<!--                    <i class="fa fa-calendar" aria-hidden="true"></i>-->
<!--                      {{industryDetails[0]['industry_type']}}-->
<!--                  </span>-->
<!--                  </div>-->


<!--                  <div class="col-md-6 " style="margin-top: 1%">-->

<!--                    <div class="col-md-8 d-flex-row">-->

<!--                      <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="industryName"  style="width: 100%;" type="text"-->
<!--                              placeholder="Search Industry by Name"-->
<!--                              class="form-control"-->

<!--                              />-->
<!--                    </div>-->
<!--                    <div class="col-md-4">-->
<!--                      <button class="btn btn-primary" (click)="getIndustryList()" > <i class="icon icon-search4"></i> Search </button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->


<!--              </div>-->

<!--              <div class="col-lg-12" *ngIf="industryDetailsLoader">-->
<!--                <div class="col-md-12" style="text-align: center;">-->
<!--                  <img src="/assets/images/load.gif" />-->
<!--                </div>-->
<!--              </div>-->

<!--              <div *ngIf="!industryDetailsLoader" class="col-lg-2" id="slideBtns" style="margin-top: 25px; float:right;">-->
<!--                <i style="color:#000000; margin-left: 20px; float:right; cursor: hand; " id="btnNext" class="fa fa-toggle-right" (click)="nextShow()"></i>-->
<!--                <i style=" cursor: hand; color:#000000; margin-left: 20px; display:none;float:right;" id="btnPlay" class="fa fa-play" (click)="playShow()"></i>-->
<!--                <i style=" cursor: hand; color:#000000; margin-left: 20px; float:right;" id="btnPause" class="fa fa-pause" (click)="pauseShow()"></i>-->
<!--                <i style=" cursor: hand; color:#000000; float:right;" id="btnPrev" class="fa fa-toggle-left" (click)="prevShow()"></i>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; Industry Detail Section End &ndash;&gt;-->

<!--    <div class="row" *ngIf="showSlide">-->
<!--      <div class="col-lg-12">-->

<!--        <div class="col-sm-6 col-md-3 card-list-item" (click)="openModal(template, 'total_exceedances_records', slideShowCardCount.total_exceedances_records)">-->
<!--          <div class="panel panel-body bg-danger-400 has-bg-image">-->
<!--            <div class="media no-margin">-->
<!--              <div class="media-body">-->
<!--                <h3 class="no-margin" *ngIf="!countLoader">{{slideShowCardCount.total_exceedances?slideShowCardCount.total_exceedances:0}}</h3>-->
<!--                <span class="no-margin" *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>-->
<!--                <span class="text-uppercase text-size-mini">Total Exceedances (in a Week)</span>-->
<!--              </div>-->

<!--              <div class="media-right media-middle">-->
<!--                <i class="icon-stats-growth2 icon-3x opacity-75"></i>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="col-sm-6 col-md-3 card-list-item" (click)="openModal(template, 'monitoring_stations_records', slideShowCardCount.monitoring_stations_records)">-->
<!--          <div class="panel panel-body bg-primary-400 has-bg-image">-->
<!--            <div class="media no-margin">-->
<!--              <div class="media-body">-->
<!--                <h3 class="no-margin" *ngIf="!countLoader">{{slideShowCardCount.monitoring_stations?slideShowCardCount.monitoring_stations:0}}</h3>-->
<!--                <span class="no-margin" *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>-->
<!--                <span class="text-uppercase text-size-mini">Monitoring Stations</span>-->
<!--              </div>-->

<!--              <div class="media-right media-middle">-->
<!--                <i class="fa fa-desktop fa-3x opacity-75"></i>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="col-sm-6 col-md-3 card-list-item" (click)="openModal(template, 'parameters_monitored', slideShowCardCount.parameters_monitored)">-->
<!--          <div class="panel panel-body bg-success-400 has-bg-image">-->
<!--            <div class="media no-margin">-->
<!--              <div class="media-body">-->
<!--                <h3 *ngIf="!countLoader" class="no-margin">{{slideShowCardCount.no_of_parameters_monitored?slideShowCardCount.no_of_parameters_monitored:0}}</h3>-->
<!--                <span class="no-margin" *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>-->
<!--                <span class="text-uppercase text-size-mini">Parameters Monitored</span>-->
<!--              </div>-->

<!--              <div class="media-right media-middle">-->
<!--                <i class="fa fa-area-chart fa-3x opacity-75"></i>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="col-sm-6 col-md-3 card-list-item" (click)="openModal(template, 'exceeding_parameters_records', slideShowCardCount.exceeding_parameters_records)">-->
<!--          <div class="panel panel-body bg-warning-400 has-bg-image">-->
<!--            <div class="media no-margin">-->

<!--              <div class="media-body">-->
<!--                <h3 *ngIf="!countLoader" class="no-margin">{{slideShowCardCount.exceeding_parameters?slideShowCardCount.exceeding_parameters:0}}</h3>-->
<!--                <span class="no-margin" *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>-->
<!--                <span class="text-uppercase text-size-mini">Exceeding Parameters</span>-->
<!--              </div>-->

<!--              <div class="media-right media-middle">-->
<!--                <i class="icon-stats-growth2 icon-3x opacity-75"></i>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="row" *ngIf="showSlide">-->
<!--      <div class="col-lg-12">-->
<!--        <div class="col-lg-2">-->

<!--          <div>-->
<!--            <div class="panel panel-body">-->
<!--              <div class="media">-->
<!--                <div *ngIf="!industryDetailsLoader" class="media-body">-->
<!--                  <span style="font-size: 12px; font-weight: bold;" class="media-heading">Last Data Fetched</span>-->
<!--                  <p style="font-size: 14px;" class="text-muted" *ngIf="industryDetails.length && industryDetails[0]['last_update_date']">{{industryDetails[0]['last_update_date'] | date: 'dd/MM/yyyy H:mm'}} Hrs</p>-->
<!--                  <p style="font-size: 14px;" class="text-muted" *ngIf="!industryDetails.length || !industryDetails[0]['last_update_date']">No Response</p>-->

<!--                  <ul class="icons-list" style="text-align: center;">-->
<!--                    <li>-->
<!--                      &lt;!&ndash; <img src="/assets/images/profile-icon/15.png" style="width: 60%;"> &ndash;&gt;-->
<!--                    </li>-->
<!--                    <li *ngIf="industryDetails.length && industryDetails[0]">-->
<!--                      <img title="Online" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Online'" src="/assets/images/profile-icon/online.png" style="width: 60%;">-->
<!--                      <img title="Offline" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Offline'" src="/assets/images/profile-icon/offline.png" style="width: 60%;">-->
<!--                      <img title="Delay" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Delay'" src="/assets/images/profile-icon/delay.png" style="width: 60%;">-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                </div>-->

<!--                <div *ngIf="industryDetailsLoader" class="media-body">-->
<!--                  <div class="col-md-12" style="text-align: center;">-->
<!--                    <img src="/assets/images/load.gif" />-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div>-->
<!--            <div class="panel text-center">-->
<!--              <div class="panel-body" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader"-->
<!--              style="padding-top:14px; padding-bottom:10px;">-->
<!--                &lt;!&ndash; <div style="font-size: 12px; font-weight: bold; text-align: center;">15 minutes Average </div> &ndash;&gt;-->
<!--                <div style="font-size: 12px; font-weight: bold; text-align: center;">Actual </div>-->

<!--                  <div class="content-group-sm svg-center position-relative" style="text-align: center">-->
<!--                  <div class="circle">-->
<!--                    <span style="text-align: center;font-size: large;" *ngIf="latestParameterDetail.value"> {{latestParameterDetail.value}} {{(latestParameterDetail.response_unit && latestParameterDetail.response_unit.toLowerCase() == 'ph' ? 'pH' : latestParameterDetail.response_unit)}}</span>-->
<!--                    <span style="text-align: center;font-size: large;" *ngIf="!latestParameterDetail.value">NA</span>-->
<!--                  </div>-->

<!--                  <div style="margin-top: 10px; font-size: 14px;">{{latestParameterDetail.param_name?(latestParameterDetail.param_name.toLowerCase() == 'ph' ? 'pH' : latestParameterDetail.param_name):'NA'}}</div>-->

<!--                  <div style="margin-top: 2px; font-size: 12px; color: #777;" *ngIf="latestParameterDetail.min || latestParameterDetail.max">Prescribed Standard:<br/> <span *ngIf="latestParameterDetail.min">{{latestParameterDetail.min}} -</span> {{latestParameterDetail.max}} {{latestParameterDetail.std_unit}}</div>-->
<!--                  <div style="margin-top: 2px; font-size: 12px; color: #777;" *ngIf="!latestParameterDetail.min && !latestParameterDetail.max">Prescribed Standard:<br/> NA</div>-->
<!--                </div>-->

<!--              </div>-->

<!--              <div  *ngIf="slideShowCardLoader || slideShowLatestLoader || countLoader" class="panel-body" style="height: 240px; text-align: center;">-->
<!--                <img style="margin-top: 30%;" src="/assets/images/load.gif" />-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="col-lg-8 panel panel-flat" id="slideShowChart" style="text-align: center;">-->
<!--          <div class="panel-heading">-->
<!--            <h5 class="panel-title" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader">{{latestParameterDetail.param_name?(latestParameterDetail.param_name.toLowerCase()=='ph' ? 'pH' : latestParameterDetail.param_name):''}} ({{slideShowCardCount.parameters_monitored[0].station_name? slideShowCardCount.parameters_monitored[0].station_name:''}}) Device Response Chart<a class="heading-elements-toggle"><i class="icon-more"></i></a></h5>-->
<!--            <div class="heading-elements">-->
<!--              <ul class="icons-list">-->
<!--                <li>-->

<!--                  <select [(ngModel)]="timeRange" (change)="setTimeRange()" class="form-control">-->
<!--                    <option value="1"> 1 Day </option>-->
<!--                    <option value="3"> 3 Days </option>-->
<!--                    <option value="7"> 7 Days </option>-->
<!--                    <option value="30"> 30 Days </option>-->
<!--                  </select>-->

<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash;<div [chart]="parameterAllResponse" *ngIf="graphPlot" [hidden]="viewDataDetailsLoader" style="height: 400px; min-width: 310px"></div>&ndash;&gt;-->
<!--          <div class="panel-body" [chart]="parameterAllResponse" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader && graphPlot" style="height: 350px;"></div>-->
<!--          <div class="panel-body text-center" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader && !graphPlot"  style="height: 350px;">-->
<!--            <div class="label label-danger" style="margin-top: 150px;">No Response Found For Selected Time Range</div>-->
<!--          </div>-->

<!--          <div class="panel-body text-center" style="height: 350px;" *ngIf="slideShowCardLoader || slideShowLatestLoader || countLoader">-->
<!--              <img style="margin-top: 15%;" src="/assets/images/load.gif" />-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="col-lg-2">-->

<!--          <div class="panel panel-flat">-->
<!--            <div class="panel-heading" style="padding-top: 10px; padding-bottom: 10px;">-->
<!--              <h5 class="panel-title">Parameter List<a class="heading-elements-toggle"><i class="icon-more"></i></a></h5>-->
<!--            </div>-->

<!--            <table class="panel-body table" *ngIf="!countLoader">-->
<!--              <tbody>-->
<!--                <tr *ngFor="let parameter_detail of slideShowCardCount.parameters_monitored let i = index" [attr.data-index]="i">-->
<!--                  <td style="font-size: 15px;">-->
<!--                    <div style="word-break: break-all;">-->
<!--                      {{parameter_detail.station_name}} Station-->
<!--                    </div>-->

<!--                    <div>-->
<!--                      <div style="text-align: center;">-->
<!--                        <span class="label label-primary" *ngIf="slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]">{{parameter_detail.parameter_name?parameter_detail.parameter_name:'NA'}} Parameter </span>-->
<!--                        <span *ngIf="!(slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey])">{{parameter_detail.parameter_name?(parameter_detail.parameter_name.toLowerCase()=='ph' ? 'pH' : parameter_detail.parameter_name):'NA'}} Parameter </span>-->

<!--                        &lt;!&ndash;<span  *ngIf="slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]['value']" style="color: #00B3F5; text-align: center;" class="text-bold">&ndash;&gt;-->
<!--                          &lt;!&ndash;{{slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]['value']}} {{ slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]['unit'] }}&ndash;&gt;-->
<!--                        &lt;!&ndash;</span>&ndash;&gt;-->

<!--                        &lt;!&ndash;<span *ngIf="!(slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]['value'])" style="color: #00B3F5; text-align: center;" class="text-bold">&ndash;&gt;-->
<!--                          &lt;!&ndash;No Response&ndash;&gt;-->
<!--                        &lt;!&ndash;</span>&ndash;&gt;-->

<!--                      </div>-->

<!--                      <div style="text-align: center; color: #777; font-size: small;">-->
<!--                        Prescribed Standard-->
<!--                        <br/>-->

<!--                        <span *ngIf="parameter_detail.min || parameter_detail.max">-->
<!--                          <span *ngIf="parameter_detail.min">{{parameter_detail.min}} - </span>-->
<!--                          <span *ngIf="parameter_detail.max">{{parameter_detail.max}} {{parameter_detail.stdunit}}</span>-->
<!--                        </span>-->

<!--                        <span *ngIf="!parameter_detail.min && !parameter_detail.max">-->
<!--                          NA-->
<!--                        </span>-->
<!--                      </div>-->

<!--                    </div>-->
<!--                  </td>-->
<!--                </tr>-->
<!--                &lt;!&ndash;<tr style="background-color: #F9FAFC;">&ndash;&gt;-->
<!--                  &lt;!&ndash;<td style="font-size: 15px;">ETP - COD - 65.8 mg/l <br/>&ndash;&gt;-->
<!--                    &lt;!&ndash;<span style="font-size: small;" class="pull-right">Standard - 250 mg/l</span>&ndash;&gt;-->
<!--                  &lt;!&ndash;</td>&ndash;&gt;-->
<!--                &lt;!&ndash;</tr>&ndash;&gt;-->
<!--                &lt;!&ndash;<tr style="background-color: #F9FAFC;">&ndash;&gt;-->
<!--                  &lt;!&ndash;<td style="font-size: 15px;">ETP - TSS - 18 mg/l <br/>&ndash;&gt;-->
<!--                    &lt;!&ndash;<span style="font-size: small;" class="pull-right">Standard - 100 mg/l</span>&ndash;&gt;-->
<!--                  &lt;!&ndash;</td>&ndash;&gt;-->
<!--                &lt;!&ndash;</tr>&ndash;&gt;-->
<!--              </tbody>-->
<!--            </table>-->

<!--            <div class="row" *ngIf="countLoader">-->
<!--              <div class="col-md-12" style="height: 340px; text-align: center;">-->
<!--                <img style="margin-top: 50%;" src="/assets/images/load.gif" />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->


<!--    <div class="row" *ngIf="!showSlide">-->
<!--      <div class="col-lg-12 text-center" style="height: 180px;">-->
<!--        <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 150px;">No Industry Found</div>-->
<!--      </div>-->
<!--    </div>-->

<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--<ng-template #template>-->
<!--  <div class="modal-header">-->
<!--    <h4 class="modal-title pull-left">{{modalTitle}}</h4>-->
<!--    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">-->
<!--      <span aria-hidden="true">×</span>-->
<!--    </button>-->
<!--  </div>-->

<!--  <div *ngIf="modalType=='total_exceedances_records'" class="modal-body">-->
<!--    <div class="table-responsive">-->
<!--      <table class="table datatable-show-all">-->
<!--        <thead>-->
<!--        <tr>-->
<!--          <th >S.No</th>-->
<!--          <th >Parameter Name</th>-->
<!--          <th >Exceedance Date</th>-->
<!--          <th >Value</th>-->
<!--        </tr>-->
<!--        </thead>-->

<!--        <tbody *ngIf="!industryListLoader &&  modalData.length">-->
<!--        <tr *ngFor="let element of modalData let i = index" [attr.data-index]="i">-->
<!--          <th>{{i+1}}</th>-->
<!--          <th>{{element.paramkey ? element.paramkey.toLowerCase() == 'ph' ? 'pH' : element.paramkey.toUpperCase() : ''}}</th>-->
<!--          <th>-->
<!--            {{element.excedance_date | date}} {{element.excedance_date | date: 'shortTime'}}-->
<!--          </th>-->
<!--          <th>{{element.value}}</th>-->
<!--        </tr>-->
<!--        </tbody>-->

<!--      </table>-->
<!--    </div>-->

<!--  </div>-->

<!--  <div *ngIf="modalType=='monitoring_stations_records'" class="modal-body">-->
<!--    <div class="table-responsive">-->
<!--      <table class="table datatable-show-all">-->
<!--        <thead>-->
<!--        <tr>-->
<!--          <th >S.No</th>-->
<!--          <th >Station Name</th>-->
<!--          <th >Type</th>-->
<!--        </tr>-->
<!--        </thead>-->

<!--        <tbody *ngIf="!industryListLoader &&  modalData.length">-->
<!--        <tr *ngFor="let element of modalData let i = index" [attr.data-index]="i">-->
<!--          <th>{{i+1}}</th>-->
<!--          <th>{{element.name}}</th>-->
<!--          <th>{{element.station_type}}</th>-->
<!--        </tr>-->
<!--        </tbody>-->

<!--      </table>-->
<!--    </div>-->

<!--  </div>-->

<!--  <div *ngIf="modalType=='parameters_monitored'" class="modal-body">-->
<!--    <div class="table-responsive">-->
<!--      <table class="table datatable-show-all">-->
<!--        <thead>-->
<!--        <tr>-->
<!--          <th >S.No</th>-->
<!--          <th >Station Name</th>-->
<!--          <th >Parameter Name</th>-->
<!--          <th >Unit</th>-->
<!--        </tr>-->
<!--        </thead>-->

<!--        <tbody *ngIf="!industryListLoader &&  modalData.length">-->
<!--        <tr *ngFor="let element of modalData let i = index" [attr.data-index]="i">-->
<!--          <th>{{i+1}}</th>-->
<!--          <th>{{element.station_name}}</th>-->
<!--          <th>{{element.paramkey ? element.paramkey.toLowerCase() == 'ph' ? 'pH' : element.paramkey.toUpperCase() : ''}}</th>-->
<!--          <th>{{element.stdunit ? element.stdunit.toLowerCase() == 'ph' ? 'pH' : element.stdunit : ''}}</th>-->
<!--        </tr>-->
<!--        </tbody>-->

<!--      </table>-->
<!--    </div>-->

<!--  </div>-->

<!--  <div *ngIf="modalType=='exceeding_parameters_records'" class="modal-body">-->
<!--    <div class="table-responsive">-->
<!--      <table class="table datatable-show-all">-->
<!--        <thead>-->
<!--        <tr>-->
<!--          <th >S.No</th>-->
<!--          <th >Parameter Name</th>-->
<!--          <th >Unit</th>-->
<!--        </tr>-->
<!--        </thead>-->

<!--        <tbody *ngIf="!industryListLoader &&  modalData.length">-->
<!--        <tr *ngFor="let element of modalData let i = index" [attr.data-index]="i">-->
<!--          <th>{{i+1}}</th>-->
<!--          <th>{{element.paramkey ? element.paramkey.toLowerCase() == 'ph' ? 'pH' : element.paramkey.toUpperCase() : ''}}</th>-->
<!--          <th>{{element.stdunit ? element.stdunit.toLowerCase() == 'ph' ? 'pH' : element.stdunit : ''}}</th>-->
<!--        </tr>-->
<!--        </tbody>-->

<!--      </table>-->
<!--    </div>-->

<!--  </div>-->

<!--  <div class="modal-footer">-->
<!--    <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>-->
<!--  </div>-->
<!--</ng-template>-->
<!--<app-footer></app-footer>-->
<app-header></app-header>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">

      <!-- Industry Detail Section Start -->
      <div class="row mb-3" *ngIf="showSlide">
        <div class="col-12">
          <div class="card border-0 shadow-sm" id="divDetails" style="color:#5A85A3; font-size: 18px;">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-md-6" *ngIf="!industryDetailsLoader && showSlide">
                  <span class="fs-3">
                    {{industryDetails[0]['name']}}
                  </span>
                  <div class="mt-2">
                    <span class="fs-6 me-3">
                      <i class="fas fa-map-marker-alt"></i>
                      {{industryDetails[0]['address']}}
                    </span>
                    <span class="fs-6">
                      <i class="fas fa-calendar-alt"></i>
                      {{industryDetails[0]['industry_type']}}
                    </span>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="!industryDetailsLoader && showSlide">
                  <div class="row g-2 align-items-center">
                    <div class="col-8">
                      <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="industryName"
                             type="text" placeholder="Search Industry by Name"
                             class="form-control form-control-sm">
                    </div>
                    <div class="col-4">
                      <button class="btn btn-primary btn-sm w-100" (click)="getIndustryList()">
                        <i class="icon icon-search4"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 text-center" *ngIf="industryDetailsLoader">
                <img src="/assets/images/load.gif" />
              </div>

              <div *ngIf="!industryDetailsLoader" class="position-absolute top-0 end-0 mt-3 me-3" id="slideBtns">
                <i class="fa fa-toggle-left me-2 cursor-pointer" id="btnPrev" (click)="prevShow()"></i>
                <i class="fa fa-pause me-2 cursor-pointer" id="btnPause" (click)="pauseShow()"></i>
                <i class="fa fa-play me-2 cursor-pointer d-none" id="btnPlay" (click)="playShow()"></i>
                <i class="fa fa-toggle-right cursor-pointer" id="btnNext" (click)="nextShow()"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Industry Detail Section End -->

      <!-- Stats Cards Section -->
      <div class="row mb-3 g-3" *ngIf="showSlide">
        <div class="col-sm-6 col-md-3 card-list-item" (click)="openModal(template, 'total_exceedances_records', slideShowCardCount.total_exceedances_records)">
          <div class="card bg-danger text-white h-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h3 class="mb-0" *ngIf="!countLoader">{{slideShowCardCount.total_exceedances?slideShowCardCount.total_exceedances:0}}</h3>
                  <span *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>
                  <span class="text-uppercase small">Total Exceedances (in a Week)</span>
                </div>
                <div class="ms-3">
                  <i class="fas fa-chart-line fa-2x opacity-75"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3 card-list-item" (click)="openModal(template, 'monitoring_stations_records', slideShowCardCount.monitoring_stations_records)">
          <div class="card bg-primary text-white h-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h3 class="mb-0" *ngIf="!countLoader">{{slideShowCardCount.monitoring_stations?slideShowCardCount.monitoring_stations:0}}</h3>
                  <span *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>
                  <span class="text-uppercase small">Monitoring Stations</span>
                </div>
                <div class="ms-3">
                  <i class="fas fa-desktop fa-2x opacity-75"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3 card-list-item" (click)="openModal(template, 'parameters_monitored', slideShowCardCount.parameters_monitored)">
          <div class="card bg-success text-white h-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h3 class="mb-0" *ngIf="!countLoader">{{slideShowCardCount.no_of_parameters_monitored?slideShowCardCount.no_of_parameters_monitored:0}}</h3>
                  <span *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>
                  <span class="text-uppercase small">Parameters Monitored</span>
                </div>
                <div class="ms-3">
                  <i class="fas fa-chart-area fa-2x opacity-75"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3 card-list-item" (click)="openModal(template, 'exceeding_parameters_records', slideShowCardCount.exceeding_parameters_records)">
          <div class="card bg-warning text-white h-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h3 class="mb-0" *ngIf="!countLoader">{{slideShowCardCount.exceeding_parameters?slideShowCardCount.exceeding_parameters:0}}</h3>
                  <span *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>
                  <span class="text-uppercase small">Exceeding Parameters</span>
                </div>
                <div class="ms-3">
                  <i class="fas fa-chart-line fa-2x opacity-75"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content Section -->
      <div class="row g-3" *ngIf="showSlide">
        <!-- Left Sidebar -->
        <div class="col-lg-2">
          <div class="card mb-3">
            <div class="card-body">
              <div *ngIf="!industryDetailsLoader" class="text-center">
                <span class="small fw-bold">Last Data Fetched</span>
                <p class="text-muted small" *ngIf="industryDetails.length && industryDetails[0]['last_update_date']">
                  {{industryDetails[0]['last_update_date'] | date: 'dd/MM/yyyy H:mm'}} Hrs
                </p>
                <p class="text-muted small" *ngIf="!industryDetails.length || !industryDetails[0]['last_update_date']">
                  No Response
                </p>

                <div class="mt-3">
                  <img *ngIf="industryDetails.length && industryDetails[0] && (industryDetails[0]['last_update_date'] | industryStatus) == 'Online'"
                       title="Online" src="/assets/images/profile-icon/online.png" style="width: 60%;">
                  <img *ngIf="industryDetails.length && industryDetails[0] && (industryDetails[0]['last_update_date'] | industryStatus) == 'Offline'"
                       title="Offline" src="/assets/images/profile-icon/offline.png" style="width: 60%;">
                  <img *ngIf="industryDetails.length && industryDetails[0] && (industryDetails[0]['last_update_date'] | industryStatus) == 'Delay'"
                       title="Delay" src="/assets/images/profile-icon/delay.png" style="width: 60%;">
                </div>
              </div>

              <div *ngIf="industryDetailsLoader" class="text-center">
                <img src="/assets/images/load.gif" />
              </div>
            </div>
          </div>

          <div class="card text-center">
            <div class="card-body" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader"
                 style="padding: 1rem 0.5rem;">
              <div class="small fw-bold">Actual</div>
              <div class="my-3">
                <div class="rounded-circle bg-light d-inline-flex align-items-center justify-content-center"
                     style="width: 100px; height: 100px;">
                  <span *ngIf="latestParameterDetail.value" class="fs-4">
                    {{latestParameterDetail.value}} {{(latestParameterDetail.response_unit && latestParameterDetail.response_unit.toLowerCase() == 'ph' ? 'pH' : latestParameterDetail.response_unit)}}
                  </span>
                  <span *ngIf="!latestParameterDetail.value" class="fs-4">NA</span>
                </div>
                <div class="mt-2 fs-5">
                  {{latestParameterDetail.param_name?(latestParameterDetail.param_name.toLowerCase() == 'ph' ? 'pH' : latestParameterDetail.param_name):'NA'}}
                </div>
                <div class="small text-muted mt-1" *ngIf="latestParameterDetail.min || latestParameterDetail.max">
                  Prescribed Standard:<br/>
                  <span *ngIf="latestParameterDetail.min">{{latestParameterDetail.min}} -</span>
                  {{latestParameterDetail.max}} {{latestParameterDetail.std_unit}}
                </div>
                <div class="small text-muted mt-1" *ngIf="!latestParameterDetail.min && !latestParameterDetail.max">
                  Prescribed Standard:<br/> NA
                </div>
              </div>
            </div>
            <div *ngIf="slideShowCardLoader || slideShowLatestLoader || countLoader"
                 class="card-body d-flex align-items-center justify-content-center" style="height: 240px;">
              <img src="/assets/images/load.gif" />
            </div>
          </div>
        </div>

        <!-- Main Chart Area -->
        <div class="col-lg-8">
          <div class="card shadow-sm">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader">
                {{latestParameterDetail.param_name?(latestParameterDetail.param_name.toLowerCase()=='ph' ? 'pH' : latestParameterDetail.param_name):''}}
                ({{slideShowCardCount.parameters_monitored[0].station_name? slideShowCardCount.parameters_monitored[0].station_name:''}})
                Device Response Chart
              </h5>
              <select [(ngModel)]="timeRange" (change)="setTimeRange()" class="form-select form-select-sm w-auto">
                <option value="1">1 Day</option>
                <option value="3">3 Days</option>
                <option value="7">7 Days</option>
                <option value="30">30 Days</option>
              </select>
            </div>
            <div class="card-body p-0">
              <div [chart]="parameterAllResponse" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader && graphPlot"
                   style="height: 350px;"></div>
              <div class="d-flex align-items-center justify-content-center"
                   *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader && !graphPlot"
                   style="height: 350px;">
                <span class="badge bg-danger">No Response Found For Selected Time Range</span>
              </div>
              <div class="d-flex align-items-center justify-content-center"
                   style="height: 350px;"
                   *ngIf="slideShowCardLoader || slideShowLatestLoader || countLoader">
                <img src="/assets/images/load.gif" />
              </div>
            </div>
          </div>
        </div>

        <!-- Right Sidebar -->
        <div class="col-lg-2">
          <div class="card shadow-sm">
            <div class="card-header">
              <h5 class="card-title mb-0">Parameter List</h5>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive" *ngIf="!countLoader">
                <table class="table table-hover mb-0">
                  <tbody>
                  <tr *ngFor="let parameter_detail of slideShowCardCount.parameters_monitored let i = index" [attr.data-index]="i">
                    <td class="small">
                      <div class="text-break">
                        {{parameter_detail.station_name}} Station
                      </div>
                      <div class="text-center mt-2">
                          <span class="badge bg-primary" *ngIf="slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]">
                            {{parameter_detail.parameter_name?parameter_detail.parameter_name:'NA'}} Parameter
                          </span>
                        <span *ngIf="!(slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey])">
                            {{parameter_detail.parameter_name?(parameter_detail.parameter_name.toLowerCase()=='ph' ? 'pH' : parameter_detail.parameter_name):'NA'}} Parameter
                          </span>
                      </div>
                      <div class="text-center small text-muted mt-1">
                        Prescribed Standard
                        <br/>
                        <span *ngIf="parameter_detail.min || parameter_detail.max">
                            <span *ngIf="parameter_detail.min">{{parameter_detail.min}} - </span>
                            <span *ngIf="parameter_detail.max">{{parameter_detail.max}} {{parameter_detail.stdunit}}</span>
                          </span>
                        <span *ngIf="!parameter_detail.min && !parameter_detail.max">
                            NA
                          </span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="countLoader" class="d-flex align-items-center justify-content-center" style="height: 340px;">
                <img src="/assets/images/load.gif" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Industry Found Section -->
      <div class="row" *ngIf="!showSlide">
        <div class="col-12 d-flex align-items-center justify-content-center" style="height: 180px;">
          <div class="fs-3 fw-bold text-danger">No Industry Found</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Template -->
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
  </div>

  <div *ngIf="modalType=='total_exceedances_records'" class="modal-body">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>S.No</th>
          <th>Parameter Name</th>
          <th>Exceedance Date</th>
          <th>Value</th>
        </tr>
        </thead>
        <tbody *ngIf="!industryListLoader && modalData.length">
        <tr *ngFor="let element of modalData let i = index" [attr.data-index]="i">
          <td>{{i+1}}</td>
          <td>{{element.paramkey ? element.paramkey.toLowerCase() == 'ph' ? 'pH' : element.paramkey.toUpperCase() : ''}}</td>
          <td>{{element.excedance_date | date}} {{element.excedance_date | date: 'shortTime'}}</td>
          <td>{{element.value}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="modalType=='monitoring_stations_records'" class="modal-body">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>S.No</th>
          <th>Station Name</th>
          <th>Type</th>
        </tr>
        </thead>
        <tbody *ngIf="!industryListLoader && modalData.length">
        <tr *ngFor="let element of modalData let i = index" [attr.data-index]="i">
          <td>{{i+1}}</td>
          <td>{{element.name}}</td>
          <td>{{element.station_type}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="modalType=='parameters_monitored'" class="modal-body">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>S.No</th>
          <th>Station Name</th>
          <th>Parameter Name</th>
          <th>Unit</th>
        </tr>
        </thead>
        <tbody *ngIf="!industryListLoader && modalData.length">
        <tr *ngFor="let element of modalData let i = index" [attr.data-index]="i">
          <td>{{i+1}}</td>
          <td>{{element.station_name}}</td>
          <td>{{element.paramkey ? element.paramkey.toLowerCase() == 'ph' ? 'pH' : element.paramkey.toUpperCase() : ''}}</td>
          <td>{{element.stdunit ? element.stdunit.toLowerCase() == 'ph' ? 'pH' : element.stdunit : ''}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="modalType=='exceeding_parameters_records'" class="modal-body">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>S.No</th>
          <th>Parameter Name</th>
          <th>Unit</th>
        </tr>
        </thead>
        <tbody *ngIf="!industryListLoader && modalData.length">
        <tr *ngFor="let element of modalData let i = index" [attr.data-index]="i">
          <td>{{i+1}}</td>
          <td>{{element.paramkey ? element.paramkey.toLowerCase() == 'ph' ? 'pH' : element.paramkey.toUpperCase() : ''}}</td>
          <td>{{element.stdunit ? element.stdunit.toLowerCase() == 'ph' ? 'pH' : element.stdunit : ''}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Close</button>
  </div>
</ng-template>

<app-footer></app-footer>
